import { Page, PageSkeleton, SelectFilter } from '@/components';
import { Heading, Flex, useTableProps } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import AuctionParametersTable from './AuctionParametersTable';
import EventsTable from './EventsTable';
import ParametersTable from './ParametersTable';
import { useSearchParams } from '@/hooks';
import { ILK_PARAMETERS } from '@/constants';
import { useMemo } from 'react';

export default function ParametersPage() {
  const [daysAgo] = useSearchParams('days_ago', '7');
  const { ilk, group } = useParams();
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 5,
    initialSorting: '-datetime',
    filtersDebounceTime: 50,
    initialFilters: { active: '0' }
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All parameters', value: '' }];
    options.push(
      ...Object.entries(ILK_PARAMETERS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.parameter
      }))
    );
    return options;
  }, [filters]);

  if (ilk) {
    return (
      <Page title={`${ilk} Parameters`}>
        <Flex flexDirection="column" gap={['m', 's']}>
          <Heading size="3">Parameters</Heading>
          <ParametersTable ilk={ilk} daysAgo={daysAgo} />
          <AuctionParametersTable ilk={ilk} daysAgo={daysAgo} />
          <Flex
            gap="2xs"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center">
            <Heading size="3">Changes</Heading>
            <SelectFilter
              key="parameter-filter"
              filterField="parameter"
              options={selectFilterOptions}
              {...filters}
            />
          </Flex>
          <EventsTable
            ilk={ilk}
            group={group}
            pagination={pagination}
            sorting={sorting}
            filters={filters}
          />
        </Flex>
      </Page>
    );
  }
  return <PageSkeleton />;
}
